import TamanioList from './TamanioList'
export {TamanioList}
export default TamanioList
